/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import { PARENT_URL } from '@apps/config';
import getJpjRunningNumber from '@apps/config/API/jpj-running-number.config';
import CarPlateScreen from '@apps/screens/CarPlate';
import { Breadcrumb } from '@stack/ui/components';
import { BreadCrumbOptions } from '@stack/ui/components/Breadcrumb/props';
import Dayjs from 'dayjs';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  // ======================= HOOKS
  const { t } = useTranslation('common');
  const [data, setData] = useState<any>();

  const fetchData = async () => {
    try {
      const res = await getJpjRunningNumber({ featured: false });
      setData(res.data);
    } catch (err) {
      console.log('err', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const lastUpdatedAt = data?.last_updated ?? new Date();

  // ======================= STATE

  // ======================= VARIABLES
  const breadcrumbOpt: BreadCrumbOptions[] = [
    {
      title: t('jpjRunningNumbers'),
    },
  ];

  // ======================= VIEWS
  return (
    <>
      <NextSeo canonical={`${PARENT_URL}/car-plate`} />
      <div>
        <Breadcrumb options={breadcrumbOpt} />
        <h1 className="text-3xl" style={{ marginBottom: 0 }}>
          {t('jpjRunningNumbers')}
        </h1>
        <h5
          className="text-sm"
          style={{
            fontWeight: 400,
            color: '#A8B5C9',
            margin: 0,
          }}
        >
          {`${t('lastUpdated')} ${Dayjs(lastUpdatedAt).format('DD MMM, YYYY')}`}
        </h5>
        <CarPlateScreen {...props} jpjNumber={data} />
      </div>
    </>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
